import React from "react";
import "./top-division-c.css";
import MytypedComponent from "../typing-effect/typing.js";

import { TOP_SECTION } from "../../Module/General";

function Btn(props) {
  return (
    <div
   
    >
      
    </div>
  );
}

function About() {
  return (
    <div className="AboutMe">
      <h2>{TOP_SECTION.TITLE}</h2>
      <MytypedComponent />
    </div>
  );
}


function Myinfo() {
  return (
    <div className="Myinfo">
      <About />
      <br />
      <p className="shortjoin"> {TOP_SECTION.SHORT_DESCRIPTION}</p>
      <br /><br />
      <a
        href="https://forms.gle/Yg2Q1ww8UTvSkZhXA"
        rel="noreferrer"
        target="_blank"
      >
        <button class="reg-button"  style={{width:230 , height:50,borderRadius:"15px", marginRight:"10px"}}>
        <i class="fa-solid fa-users" style={{marginRight:"5px"}}></i>
          Reserve your Spot
        </button>
      </a>
     
      <a
        href="https://discord.gg/v5Jz567Q"
        rel="noreferrer"
        target="_blank"
      >
        <button class="dis-button" style={{width:200 , height:50,borderRadius:"15px"}}>
         
          <i class="fa-brands fa-discord" style={{marginRight:"5px"}}></i> Join Discord
        </button>
      </a>
      <br /><br />
    
    </div>


  );
}

export { Btn, Myinfo };
